import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { Home, Users, FileText, Gift, LogOut } from 'lucide-react';
import { AppLayout } from '@/components/templates/AppLayout';
import { Button } from '@/components/atoms/Button';
import { ROUTES } from '@/constants/routes';
import { useAuth } from '@/hooks/useAuth';
import { useCompanyScope } from '@/hooks/useCompanyScope';
import { clearCompanyScope } from '@/services/companyScope';
import type { NavItem } from '@/components/organisms/Sidebar';
import styles from './CompanyLayout.module.scss';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: ROUTES.COMPANY.DASHBOARD, icon: Home },
  { label: 'Employees', path: ROUTES.COMPANY.EMPLOYEES, icon: Users },
  { label: 'Reports', path: ROUTES.COMPANY.REPORTS, icon: FileText },
  { label: 'Rewards', path: ROUTES.COMPANY.REWARDS, icon: Gift },
];

export function CompanyLayout() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const scope = useCompanyScope();
  const isBackoffice = user?.role === 'backoffice';

  // Backoffice puede administrar cualquier empresa, pero no pertenece a
  // ninguna: sin empresa abierta no hay nada que mostrar aquí.
  if (isBackoffice && !scope) {
    return <Navigate to={ROUTES.BACKOFFICE.COMPANIES} replace />;
  }

  const handleExit = () => {
    clearCompanyScope();
    navigate(ROUTES.BACKOFFICE.COMPANIES);
  };

  return (
    <AppLayout navItems={NAV_ITEMS} navRole="company_admin">
      {isBackoffice && scope && (
        <div className={styles.companyLayout__scopeBanner} role="status">
          <p className={styles.companyLayout__scopeText}>
            Estás gestionando <strong>{scope.name}</strong> como backoffice.
          </p>
          <Button variant="ghost" size="sm" leftIcon={<LogOut />} onClick={handleExit}>
            Salir de la empresa
          </Button>
        </div>
      )}
      <Outlet />
    </AppLayout>
  );
}

export default CompanyLayout;
